// Sprint 4c-3 C.3 — Shared Coach-Marker (Brand-Glyph + „dein Kommunikations-Coach"-Label).
// Konsistent gemounted auf: DashboardHero, DashboardAnliegen, DashboardDreisatzBruecke.
// Gleiche Position (oben links), gleiche Größe, gleiche Farbe (Deep Teal).

import React from "react";
import Logo from "@/components/Logo";

export function CoachMarker({ className = "", testid = "coach-marker" }) {
  return (
    <div
      data-testid={testid}
      className={`flex items-center gap-3 ${className}`}
    >
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#0F766E]/10 ring-1 ring-[#0F766E]/20">
        <Logo size={22} />
      </span>
      <span className="text-xs font-bold uppercase tracking-widest text-[#0F766E]">
        dein Kommunikations-Coach
      </span>
    </div>
  );
}

export default CoachMarker;
